import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Button
} from '@mui/material';
import CloseIcon from '../../../assets/icons/closeIcon.svg';
import { ReactComponent as AlertIcon } from '../../../assets/icons/alertIcon.svg';
import { ReactElement } from 'react';

interface SimpleDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  content: any;
  customJustifyContent?: string;
}

export const InfoModal = (props: SimpleDialogProps) => {
  const { onClose, open, content, title, customJustifyContent } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: '400px',
          height: 'auto',
          borderRadius: '0.9375rem',
          padding: '0.9375rem',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <Button
        sx={{ justifyContent: 'end', padding: '0px' }}
        onClick={handleClose}
        data-testid={'#close-info-modal'}
      >
        <img src={CloseIcon} alt="Close Modal" />
      </Button>

      {title ? (
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            padding: '0px'
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Calibri',
              fontSize: '1rem',
              fontWeight: 'bold',
              fontStyle: 'italic',
              color: '#004F71'
            }}
          >
            {title}
          </Typography>
        </DialogTitle>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <AlertIcon />
        </div>
      )}

      <DialogContent
        sx={{
          overflow: 'hidden',
          display: 'flex',
          justifyContent: customJustifyContent
            ? customJustifyContent
            : 'flex-start',
          marginTop: customJustifyContent ? '0.9375rem' : '0px',
          padding: '0px'
        }}
      >
        <DialogContentText id="alert-dialog-description">
          <Typography
            sx={{
              fontFamily: 'Calibri',
              fontSize: '1rem',
              fontWeight: '450',
              color: '#004F71'
            }}
          >
            {content}
          </Typography>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};
